//formatterHelper.js
require('d3-format');

const utils = {
  format: {
    nFormatter: function (num, digits) {
      var si = [
        {value: 1, symbol: ""},
        {value: 1E3, symbol: "k"},
        {value: 1E6, symbol: "M"},
        {value: 1E9, symbol: "G"},
        {value: 1E12, symbol: "T"},
        {value: 1E15, symbol: "P"},
        {value: 1E18, symbol: "E"}
      ];
      var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var i;
      for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
          break;
        }
      }
      return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    },
    colonFormatter: function (first, last) {
      return first + " : " + last;
    },
    dateOrdinal: function (d) {
      //Thanks stackoverflow
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
    dateFormatter: function (d) {
      var inputf = d3.time.format("%Y-%m-%d");
      var outputf = d3.time.format("%b %d");
      var dayf = d3.time.format("%b %d");

      var date = inputf.parse(d);
      var day = dayf(date)

      return outputf(date) + this.dateOrdinal(day);
    },

    truncate: function (str, n) {
      if (str.length <= n)
        return str;

      var suffix = "...";

      return str.substring(0, n - suffix.length) + suffix;
    }
  },
  filter: {
    filterText: function (text) {
      var trimmedText = text.trim();
      var regex = new RegExp(trimmedText + ".*", "i");
      return function (d) {
        return regex.test(d);
      }
    }
  },
  redirect: {
    notFound: function () {
      window.location.href = "/static/404.html";
    },
    internalServerError: function () {
      window.location.href = "/static/500.html";
    }
  },
  indexPosition: function (jsonData, findThis, forWhichKey = undefined) {
    var index = -1;
    if (jsonData.isNull){
      return index;
    }
    var whichKey = "shape_id"
    if (forWhichKey){
      whichKey = "key"
    }
    for (var i=0; i<jsonData.length; i++) {
      if ( jsonData[i][whichKey] === findThis ) {
        index = i;
        break;
      }
    }
    return index;
  }

}

export default utils;



// WEBPACK FOOTER //
// ./src/modules/utils.js